<nz-layout>
  <nz-header nz-row>
    <div nz-col>
      <button nz-button nzType="primary" (click)="currenDate()">
        <i nz-icon nzType="carry-out" nzTheme="outline"></i>
      </button>
    </div>
    <div nz-col>
      <beautyapp-datepicker
        style="margin-top: 16px"
        [(ngModel)]="currentDate"
        (ngModelChange)="changeDate($event)"
        [allowClear]="false"
      ></beautyapp-datepicker>
    </div>
    <!-- beaut-365: day-form slot granularity selector (wraps on narrow screens) -->
    <div
      nz-col
      nzSpan="24"
      style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px"
    >
      <button
        nz-button
        nzSize="small"
        [nzType]="timeInterval === '00:05:00' ? 'primary' : 'default'"
        (click)="changeTimeInterval('00:05:00')"
      >5 {{ 'calendar.minute' | translate }}.</button>
      <button
        nz-button
        nzSize="small"
        [nzType]="timeInterval === '00:15:00' ? 'primary' : 'default'"
        (click)="changeTimeInterval('00:15:00')"
      >15 {{ 'calendar.minute' | translate }}.</button>
      <button
        nz-button
        nzSize="small"
        [nzType]="timeInterval === '00:20:00' ? 'primary' : 'default'"
        (click)="changeTimeInterval('00:20:00')"
      >20 {{ 'calendar.minute' | translate }}.</button>
      <button
        nz-button
        nzSize="small"
        [nzType]="timeInterval === '00:30:00' ? 'primary' : 'default'"
        (click)="changeTimeInterval('00:30:00')"
      >30 {{ 'calendar.minute' | translate }}.</button>
      <button
        nz-button
        nzSize="small"
        [nzType]="timeInterval === '01:00:00' ? 'primary' : 'default'"
        (click)="changeTimeInterval('01:00:00')"
      >1{{ 'calendar.hours' | translate }}.</button>
    </div>
  </nz-header>
  <nz-content>
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
  </nz-content>
</nz-layout>
